import React, { useCallback } from 'react';
import { Form } from '../../../ui/form/components/form';
import { ADDRESS_TARGETS, fromAtlasAddress, mergeAddresses } from './address';
import { AddressAutofillProvider } from './address-autofill-context';
import { CountryCodeProvider } from './country-code-context';
import { useExperiments } from '../../../contexts/experiments-context';
import { EXPERIMENTS } from '../../../constants/experiments';
const DO_NOTHING = () => Promise.resolve({});
const NO_VALUES = {};
const NO_ERRORS = [];
const MultilineAddress = _ref => {
  let {
    id,
    form,
    value,
    onChange,
    errors,
    FieldLayout
  } = _ref;
  const {
    isExperimentEnabled
  } = useExperiments();
  const clearOnAutofill = isExperimentEnabled(EXPERIMENTS.CLEAR_ON_AUTOFILL);
  const handleAddressSelect = useCallback(atlasAddress => {
    if (!value) {
      return;
    }
    const address = fromAtlasAddress(atlasAddress);
    if (clearOnAutofill) {
      const newValue = {
        ...address,
        [ADDRESS_TARGETS.COUNTRY]: address[ADDRESS_TARGETS.COUNTRY] ?? value[ADDRESS_TARGETS.COUNTRY]
      };
      onChange == null || onChange(newValue);
      return;
    }
    const newValue = mergeAddresses(value, address);
    onChange == null || onChange(newValue);
  }, [onChange, clearOnAutofill, value]);
  if (!form) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id
  }, /*#__PURE__*/React.createElement(CountryCodeProvider, {
    countryCode: value == null ? void 0 : value.country
  }, /*#__PURE__*/React.createElement(AddressAutofillProvider, {
    onAddressSelect: handleAddressSelect
  }, /*#__PURE__*/React.createElement(Form, {
    form: form,
    values: value ?? NO_VALUES,
    onChange: onChange ?? DO_NOTHING,
    errors: errors ?? NO_ERRORS
  }))));
};
export default MultilineAddress;
//# sourceMappingURL=multiline-address.js.map